import {ReactElement} from "react";
import {SectionContainer} from "./SharedComponents";
import {StyledBoxColumn, StyledHeadingVariant} from "@/shared/StyledComponents";
import {Typography} from "@mui/material";
import {PD_SM} from "@/shared/dimens";
import {ContactSectionData, SiteTemplate} from "../../types";

export function ContactSection(props: { data: ContactSectionData, template: SiteTemplate }): ReactElement {
  return <SectionContainer>
    <StyledBoxColumn style={{alignItems: "center", textAlign: "center", gap: PD_SM}}>
      {props.data.title
        ? <StyledHeadingVariant default_={3}>{props.data.title}</StyledHeadingVariant>
        : null}
      {props.data.subtitle
        ? <Typography style={{opacity: 0.6, maxWidth: 540, lineHeight: 1.7}}>{props.data.subtitle}</Typography>
        : null}
    </StyledBoxColumn>
    {/* TODO Add request appointment form embed */}
  </SectionContainer>;
}
